import { z } from "zod";

export enum OAuthProviderNames {
  Figma = "figma",
  Azure = "azure",
  Github = "github",
  Gitlab = "gitlab",
  Bitbucket = "bitbucket",
}

export const OAuthProviderSchema = z.nativeEnum(OAuthProviderNames);
export type OAuthProvider = z.infer<typeof OAuthProviderSchema>;
export const OAuthProvider = OAuthProviderSchema.enum;
